import { render, staticRenderFns } from "./traver.vue?vue&type=template&id=b696ee20&scoped=true&"
import script from "./traver.vue?vue&type=script&lang=js&"
export * from "./traver.vue?vue&type=script&lang=js&"
import style0 from "./traver.vue?vue&type=style&index=0&id=b696ee20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b696ee20",
  null
  
)

export default component.exports